export const GET_USER_LIST_SUCCESS = 'GET_USER_LIST_SUCCESS';
export const GET_USER_LIST_FAILURE = 'GET_USER_LIST_FAILURE';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';

export const GET_AUTH_FAILURE = 'GET_AUTH_FAILURE';
export const GET_AUTH_SUCCESS = 'GET_AUTH_SUCCESS'; 

export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';

export const GET_DASHBOARD_LIST_SUCCESS = 'GET_DASHBOARD_LIST_SUCCESS'
export const GET_DASHBOARD_LIST_FAILURE = 'GET_DASHBOARD_LIST_FAILURE'
export const GET_DASHBOARD_FAILURE = 'GET_DASHBOARD_FAILURE'
export const GET_DASHBOARD_SUCCESS = 'GET_DASHBOARD_SUCCESS'

export const GET_SUPPORT_LIST_SUCCESS = 'GET_SUPPORT_LIST_SUCCESS'
export const GET_SUPPORT_LIST_FAILURE = 'GET_SUPPORT_LIST_FAILURE'
export const GET_SUPPORT_FAILURE = 'GET_SUPPORT_FAILURE'
export const GET_SUPPORT_SUCCESS = 'GET_SUPPORT_SUCCESS'

export const GET_NOTIFICATION_LIST_SUCCESS = 'GET_NOTIFICATION_LIST_SUCCESS'
export const GET_NOTIFICATION_LIST_FAILURE = 'GET_NOTIFICATION_LIST_FAILURE'
export const GET_NOTIFICATION_FAILURE = 'GET_NOTIFICATION_FAILURE'
export const GET_NOTIFICATION_SUCCESS = 'GET_NOTIFICATION_SUCCESS'
export const UPDATE_NOTIFICATION_SUCCESS = 'UPDATE_NOTIFICATION_SUCCESS'

export const GET_PAYMENT_LIST_SUCCESS = 'GET_PAYMENT_LIST_SUCCESS'
export const GET_PAYMENT_LIST_FAILURE = 'GET_PAYMENT_LIST_FAILURE'
export const GET_PAYMENT_FAILURE = 'GET_PAYMENT_FAILURE'
export const GET_PAYMENT_SUCCESS = 'GET_PAYMENT_SUCCESS'


export const GET_AREA_LIST_SUCCESS = 'GET_AREA_LIST_SUCCESS'
export const GET_AREA_LIST_FAILURE = 'GET_AREA_LIST_FAILURE'
export const GET_AREA_FAILURE = 'GET_AREA_FAILURE'
export const GET_AREA_SUCCESS = 'GET_AREA_SUCCESS'

export const GET_CIVILSTATE_LIST_SUCCESS = 'GET_CIVILSTATE_LIST_SUCCESS'
export const GET_CIVILSTATE_LIST_FAILURE = 'GET_CIVILSTATE_LIST_FAILURE'
export const GET_CIVILSTATE_FAILURE = 'GET_CIVILSTATE_FAILURE'
export const GET_CIVILSTATE_SUCCESS = 'GET_CIVILSTATE_SUCCESS'

export const GET_COMMONQUESTION_LIST_SUCCESS = 'GET_COMMONQUESTION_LIST_SUCCESS'
export const GET_COMMONQUESTION_LIST_FAILURE = 'GET_COMMONQUESTION_LIST_FAILURE'
export const GET_COMMONQUESTION_FAILURE = 'GET_COMMONQUESTION_FAILURE'
export const GET_COMMONQUESTION_SUCCESS = 'GET_COMMONQUESTION_SUCCESS'

export const GET_COMPLAINT_LIST_SUCCESS = 'GET_COMPLAINT_LIST_SUCCESS'
export const GET_COMPLAINT_LIST_FAILURE = 'GET_COMPLAINT_LIST_FAILURE'
export const GET_COMPLAINT_FAILURE = 'GET_COMPLAINT_FAILURE'
export const GET_COMPLAINT_SUCCESS = 'GET_COMPLAINT_SUCCESS'

export const GET_NATIONALITY_LIST_SUCCESS = 'GET_NATIONALITY_LIST_SUCCESS'
export const GET_NATIONALITY_LIST_FAILURE = 'GET_NATIONALITY_LIST_FAILURE'
export const GET_NATIONALITY_FAILURE = 'GET_NATIONALITY_FAILURE'
export const GET_NATIONALITY_SUCCESS = 'GET_NATIONALITY_SUCCESS'

export const GET_NEWS_LIST_SUCCESS = 'GET_NEWS_LIST_SUCCESS'
export const GET_NEWS_LIST_FAILURE = 'GET_NEWS_LIST_FAILURE'
export const GET_NEWS_FAILURE = 'GET_NEWS_FAILURE'
export const GET_NEWS_SUCCESS = 'GET_NEWS_SUCCESS'

export const GET_ORGAN_LIST_SUCCESS = 'GET_ORGAN_LIST_SUCCESS'
export const GET_ORGAN_LIST_FAILURE = 'GET_ORGAN_LIST_FAILURE'
export const GET_ORGAN_FAILURE = 'GET_ORGAN_FAILURE'
export const GET_ORGAN_SUCCESS = 'GET_ORGAN_SUCCESS'

export const GET_POLL_LIST_SUCCESS = 'GET_POLL_LIST_SUCCESS'
export const GET_POLL_LIST_FAILURE = 'GET_POLL_LIST_FAILURE'
export const GET_POLL_FAILURE = 'GET_POLL_FAILURE'
export const GET_POLL_SUCCESS = 'GET_POLL_SUCCESS'

export const GET_BENEFIT_LIST_SUCCESS = 'GET_BENEFIT_LIST_SUCCESS'
export const GET_BENEFIT_LIST_FAILURE = 'GET_BENEFIT_LIST_FAILURE'
export const GET_BENEFIT_FAILURE = 'GET_BENEFIT_FAILURE'
export const GET_BENEFIT_SUCCESS = 'GET_BENEFIT_SUCCESS'

export const GET_AGREEMENT_LIST_SUCCESS = 'GET_AGREEMENT_LIST_SUCCESS'
export const GET_AGREEMENT_LIST_FAILURE = 'GET_AGREEMENT_LIST_FAILURE'
export const GET_AGREEMENT_FAILURE = 'GET_AGREEMENT_FAILURE'
export const GET_AGREEMENT_SUCCESS = 'GET_AGREEMENT_SUCCESS'

export const GET_PROMOTION_LIST_SUCCESS = 'GET_PROMOTION_LIST_SUCCESS'
export const GET_PROMOTION_LIST_FAILURE = 'GET_PROMOTION_LIST_FAILURE'
export const GET_PROMOTION_FAILURE = 'GET_PROMOTION_FAILURE'
export const GET_PROMOTION_SUCCESS = 'GET_PROMOTION_SUCCESS'

export const GET_SCHEDULE_LIST_SUCCESS = 'GET_SCHEDULE_LIST_SUCCESS'
export const GET_SCHEDULE_LIST_FAILURE = 'GET_SCHEDULE_LIST_FAILURE'
export const GET_SCHEDULE_FAILURE = 'GET_SCHEDULE_FAILURE'
export const GET_SCHEDULE_SUCCESS = 'GET_SCHEDULE_SUCCESS'

export const GET_SEX_LIST_SUCCESS = 'GET_SEX_LIST_SUCCESS'
export const GET_SEX_LIST_FAILURE = 'GET_SEX_LIST_FAILURE'
export const GET_SEX_FAILURE = 'GET_SEX_FAILURE'
export const GET_SEX_SUCCESS = 'GET_SEX_SUCCESS'

export const GET_SUBJECT_LIST_SUCCESS = 'GET_SUBJECT_LIST_SUCCESS'
export const GET_SUBJECT_LIST_FAILURE = 'GET_SUBJECT_LIST_FAILURE'
export const GET_SUBJECT_FAILURE = 'GET_SUBJECT_FAILURE'
export const GET_SUBJECT_SUCCESS = 'GET_SUBJECT_SUCCESS'

export const GET_CHARGE_LIST_SUCCESS = 'GET_CHARGE_LIST_SUCCESS'
export const GET_CHARGE_LIST_FAILURE = 'GET_CHARGE_LIST_FAILURE'
export const GET_CHARGE_FAILURE = 'GET_CHARGE_FAILURE'
export const GET_CHARGE_SUCCESS = 'GET_CHARGE_SUCCESS'

export const GET_CHARGETYPE_LIST_SUCCESS = 'GET_CHARGETYPE_LIST_SUCCESS'
export const GET_CHARGETYPE_LIST_FAILURE = 'GET_CHARGETYPE_LIST_FAILURE'
export const GET_CHARGETYPE_FAILURE = 'GET_CHARGETYPE_FAILURE'
export const GET_CHARGETYPE_SUCCESS = 'GET_CHARGETYPE_SUCCESS'

export const GET_SALARY_LIST_SUCCESS = 'GET_SALARY_LIST_SUCCESS'
export const GET_SALARY_LIST_FAILURE = 'GET_SALARY_LIST_FAILURE'
export const GET_SALARY_FAILURE = 'GET_SALARY_FAILURE'
export const GET_SALARY_SUCCESS = 'GET_SALARY_SUCCESS'

export const GET_APROVATION_LIST_SUCCESS = 'GET_APROVATION_LIST_SUCCESS'
export const GET_APROVATION_LIST_FAILURE = 'GET_APROVATION_LIST_FAILURE'
export const GET_APROVATION_FAILURE = 'GET_APROVATION_FAILURE'
export const GET_APROVATION_SUCCESS = 'GET_APROVATION_SUCCESS'

export const GET_DISTRIBUTION_LIST_SUCCESS = 'GET_DISTRIBUTION_LIST_SUCCESS'
export const GET_DISTRIBUTION_LIST_FAILURE = 'GET_DISTRIBUTION_LIST_FAILURE'
export const GET_DISTRIBUTION_FAILURE = 'GET_DISTRIBUTION_FAILURE'
export const GET_DISTRIBUTION_SUCCESS = 'GET_DISTRIBUTION_SUCCESS'


// WEBPACK FOOTER //
// ./src/store/types.js